import React, { Component, createRef } from 'react';
import Input from './Input/Input';
import Button from './Button/Button';
import Suggestions from './Suggestions/Suggestions';
import { triggerMouseEvent } from '../../utils';

export default class Search extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isButtonFocused: false,
            isInputFocused: false,
            isSuggestionFocused: false,
            inputValue: ''
        };

        this.suggestionsComponentRef = createRef();

        this.handleInput = this.handleInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.matchInputToSuggestionPick = this.matchInputToSuggestionPick.bind(this);

        // Handling subcomponent focus
        this.handleButtonFocus = this.handleButtonFocus.bind(this);
        this.handleInputFocus = this.handleInputFocus.bind(this);
        this.handleSuggestionFocus = this.handleSuggestionFocus.bind(this);
    }

    handleInput(event) {
        this.setState({
            inputValue: event.target.value
        });

        if (this.props.searchType === "map") {
            this.props.handleFilterQueryChange(event.target.value.trim());
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        let suggestionItem = this.suggestionsComponentRef.current.getActiveSuggestion();
        if (suggestionItem && suggestionItem.firstElementChild) {
            triggerMouseEvent(suggestionItem.firstElementChild, "mousedown");
            event.stopPropagation();
        }
    }

    handleInputFocus(event) {
        this.setState({
            isInputFocused: event === "focus"
        });
    }

    handleButtonFocus(event) {
        this.setState({
            isButtonFocused: event === "focus"
        });
    }

    // TODO
    handleSuggestionFocus(state) { }

    matchInputToSuggestionPick(value) {
        if (this.props.searchType === "map") {
            this.setState({
                inputValue: value
            }, this.props.handleFilterQueryChange(value));
        } else {
            this.setState({
                inputValue: value
            });
        }
    }

    render() {
        let isActive = this.state.isInputFocused ||
            this.state.isButtonFocused ||
            this.state.isSuggestionFocused;

        return (
            <form className={"search-component" + (isActive ? " active" : "")}
                onSubmit={this.handleSubmit}
                autoComplete="off">
                <Input type={this.props.searchType}
                    inputValue={this.state.inputValue}
                    placeholder={this.props.placeholder}
                    handleFocus={this.handleInputFocus}
                    handleInput={this.handleInput} />
                <Button type={this.props.buttonType}
                    handleFocus={this.handleButtonFocus} />
                <Suggestions type={this.props.searchType}
                    useEmptySearch={this.props.useEmptySearch}
                    query={this.state.inputValue.trim()}
                    ref={this.suggestionsComponentRef}
                    handleFocus={this.handleSuggestionFocus}
                    matchInputToSuggestionPick={this.matchInputToSuggestionPick}
                    handleSuggestionClick={this.props.handleSuggestionClick}
                    locations={this.props.locations} />
            </form>
        )
    }
}
